
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { GetLanguage, SetLanguage } from './language.action';

export type LanguageStateModel = {
  language: string;
}

const defaults: LanguageStateModel = {
  language: 'fr'
};

@State<LanguageStateModel>({
  name: 'language',
  defaults
})

@Injectable()
export class LanguageState {
  @Selector()
  static getLanguage(state: LanguageStateModel) {
    return state?.language ?? 'fr';
  }

  @Action(SetLanguage)
  setLanguage({ patchState }: StateContext<LanguageStateModel>, action: SetLanguage) {
    patchState({ language: action.language });
  }

  @Action(GetLanguage)
  getLanguage(ctx: StateContext<LanguageStateModel>) {
    return ctx.getState().language;
  }
}
